// For client-side SDKs, machine IP and Hostname are not captured and sent to Split backend.
export function validateRuntime() {
    return {
        ip: false,
        hostname: false
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/utils/settingsValidation/runtime.js
// module id = 1614
// module chunks = 31